import { pageTitle } from 'ember-page-title';
import { LinkTo } from '@ember/routing';

<template>
  {{pageTitle "Page Not Found - 404"}}

  <section class="flex flex-col items-center justify-center min-h-screen px-4 text-center">
    <div class="max-w-2xl mx-auto">
      <h1 class="title !mb-8">404</h1>

      <h2 class="title-sm !mb-6">Page Not Found</h2>

      <p class="text-xl mb-8 text-gray-700 dark:text-gray-300">
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
        <LinkTo
          @route="index"
          class="px-8 py-3 bg-link dark:bg-link-dark text-white rounded-lg hover:opacity-90 transition-opacity no-underline"
        >
          Go Home
        </LinkTo>

        <LinkTo
          @route="about"
          class="px-8 py-3 border-2 border-link dark:border-link-dark text-link dark:text-link-dark rounded-lg hover:bg-link hover:bg-opacity-10 transition-all no-underline"
        >
          About Me
        </LinkTo>
      </div>

      <div class="text-left max-w-md mx-auto">
        <h3 class="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">You might be looking for:</h3>
        <ul class="space-y-2 text-gray-700 dark:text-gray-300">
          <li>
            <LinkTo @route="index" class="text-link dark:text-link-dark hover:underline">
              → Home Page
            </LinkTo>
          </li>
          <li>
            <LinkTo @route="about" class="text-link dark:text-link-dark hover:underline">
              → About Me & Work Experience
            </LinkTo>
          </li>
          <li>
            <a href="https://github.com/marcemira" target="_blank" rel="noopener noreferrer" class="text-link dark:text-link-dark hover:underline">
              → GitHub Profile
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/marcemira" target="_blank" rel="noopener noreferrer" class="text-link dark:text-link-dark hover:underline">
              → LinkedIn Profile
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

